
// ======================================
// ====== Configuration =================
// ======================================



var counter;
var now;
var distance;
var hasStarted = false;

var seconds;
var minutes;
var hours;
var days;

var daysUI;
var hoursUI;
var minutesUI;
var secondsUI;

// ======================================
// ====== Running Code ==================
// ======================================

jQuery( document ).ready(function() {
    daysUI = jQuery('#counterDays');
    hoursUI = jQuery('#counterHours');
    minutesUI = jQuery('#counterMinutes');
    secondsUI = jQuery('#counterSeconds');

    var counterDate = jQuery('#counterEndDate').text();
    // if counter exists in the page, start the counter engine.
    if (counterDate) {
        counterEngine(counterDate);
    }


    // if program page.
    if (jQuery('.days-wrap').length) {
        centerProgramImages();
    }


    // animate counter border.
    $(window).load(function() {
        $("body").removeClass("preload");
      });

});




// ======================================
// ==== Counter Helper Functions ========
// ======================================
/**
 * Initialize the counter engine, to preform a countdown.
 * Keeps the counter time elements and label updated.
 * Refresh rate is 1 sec.
 * @param counterDate
 */
function counterEngine(counterDate) {
    setInterval(function() {
        counter = recalculateCounter(counterDate);
        if (hasStarted === true) {
            jQuery(".counter-title").text("התחיל לפני:");
        }
        daysUI.text(counter.days);
        hoursUI.text(counter.hours);
        minutesUI.text(counter.minutes);
        secondsUI.text(counter.seconds);

    },1000);


}

/**
 * Recalculate the counter values.
 * If time has passed, hasStarted flag will be true.
 *
 * @param counterDate
 * @returns {{hasStarted: boolean, days: number, hours: number, minutes: number, seconds: number}}
 */
function recalculateCounter(counterDate){
    now = parseInt(((new Date().getTime()) / 1000) + (2*3600));
    distance = counterDate - now;
    // if time has passed, reverse.
    if (distance < 0) {
        distance = (-1) * (distance);
        hasStarted = true;
    }
    // calc counter elements.
    var seconds = Math.floor( (distance) % 60 );
    var minutes = Math.floor( (distance / 60) % 60 );
    var hours = Math.floor( (distance / (60*60)) % 24 );
    var days = Math.floor( distance/(60*60*24) );

    return {
        'hasStarted': hasStarted,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}


// ======================================
// ==== Helper Functions ================
// ======================================
/**
 * Center the program page images in the middle of the div.
 */
function centerProgramImages() {
    jQuery('.single-event-wrap ').each(function () {
        $('.img-wrap', this).css('padding-top',($(this).height() / 2) - 25);
    });
}